// FETCH ALL ACCESSORIES MASTER
export const FETCH_ACCESSORIS_MASTER_REQUEST = 'FETCH_ACCESSORIS_MASTER_REQUEST';
export const FETCH_ACCESSORIS_MASTER_SUCCESS = 'FETCH_ACCESSORIS_MASTER_SUCCESS';
export const FETCH_ACCESSORIS_MASTER_FAILURE = 'FETCH_ACCESSORIS_MASTER_FAILURE';

export const FETCH_ACCESSORIS_MASTER_FOR_SIZE_REQUEST = 'FETCH_ACCESSORIS_MASTER_FOR_SIZE_REQUEST';
export const FETCH_ACCESSORIS_MASTER_FOR_SIZE_SUCCESS = 'FETCH_ACCESSORIS_MASTER_FOR_SIZE_SUCCESS';
export const FETCH_ACCESSORIS_MASTER_FOR_SIZE_FAILURE = 'FETCH_ACCESSORIS_MASTER_FOR_SIZE_FAILURE';

// CREATE ACCESSORIES MASTER
export const CREATE_ACCESSORIS_MASTER_REQUEST = 'CREATE_ACCESSORIS_MASTER_REQUEST';
export const CREATE_ACCESSORIS_MASTER_SUCCESS = 'CREATE_ACCESSORIS_MASTER_SUCCESS';
export const CREATE_ACCESSORIS_MASTER_FAILURE = 'CREATE_ACCESSORIS_MASTER_FAILURE';

// UPDATE ACCESSORIES MASTER
export const UPDATE_ACCESSORIS_MASTER_REQUEST = 'UPDATE_ACCESSORIS_MASTER_REQUEST';
export const UPDATE_ACCESSORIS_MASTER_SUCCESS = 'UPDATE_ACCESSORIS_MASTER_SUCCESS';
export const UPDATE_ACCESSORIS_MASTER_FAILURE = 'UPDATE_ACCESSORIS_MASTER_FAILURE';

// FETCH SINGLE STATE OF ACCESSORIES MASTER
export const FETCH_SINGLE_ACCESSORIS_MASTER_REQUEST = 'FETCH_SINGLE_ACCESSORIS_MASTER_REQUEST';
export const FETCH_SINGLE_ACCESSORIS_MASTER_SUCCESS = 'FETCH_SINGLE_ACCESSORIS_MASTER_SUCCESS';
export const FETCH_SINGLE_ACCESSORIS_MASTER_FAILURE = 'FETCH_SINGLE_ACCESSORIS_MASTER_FAILURE';

// DELETE ACCESSORIES MASTER
export const DELETE_ACCESSORIS_MASTER_REQUEST = 'DELETE_ACCESSORIS_MASTER_REQUEST';
export const DELETE_ACCESSORIS_MASTER_SUCCESS = 'DELETE_ACCESSORIS_MASTER_SUCCESS';
export const DELETE_ACCESSORIS_MASTER_FAILURE = 'DELETE_ACCESSORIS_MASTER_FAILURE';

export const FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_REQUEST = 'FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_REQUEST';
export const FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_SUCCESS = 'FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_SUCCESS';
export const FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_FAILURE = 'FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_FAILURE';

export const RESET_ACCESSORIS_MASTER_INFO = 'RESET_ACCESSORIS_MASTER_INFO';

export const CREATE_ACCESSORIS_MASTER_FORM = 'CREATE_ACCESSORIS_MASTER_FORM';

export const UPDATE_ACCESSORIS_MASTER_FORM = 'UPDATE_ACCESSORIS_MASTER_FORM';

// NAVIGATE TO SIZE RATIO COMPONENT
export const NAVIGATE_SIZE_RATIO = 'NAVIGATE_SIZE_RATIO';

// NAVIGATE TO ACCESSORIES MASTER COMPONENT
export const NAVIGATE_ACCESSORIS_MASTER = 'NAVIGATE_ACCESSORIS_MASTER';
